interface Options {
  resolver?: Function;
  cacheType?: MapConstructor | WeakMapConstructor;
}

// Create memoized function
const memoize = (func: Function, options?: Options) => {
  const { resolver, cacheType = Map } = options ?? {};

  if (typeof func !== 'function' || (resolver && typeof resolver !== 'function')) {
    throw new TypeError('memoize expect a function args');
  }

  function memoized(this: any, ...args: any[]) {
    // user can customize cache key
    // default use first args
    const key = resolver ? resolver.apply(this, args) : args[0];

    const cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    const result = func.apply(this, args);
    // update cache
    memoized.cache = cache.set(key, result) || cache;
    return result;
  }

  memoized.cache = new cacheType();
  return memoized;
};

export { memoize };
